import api from '../api'
// eslint-disable-next-line import/no-cycle
import { fetchDiscounts } from './discounts'
import { fetchBilling, fetchInvoices, fetchPreviewInvoice } from './billing'
import { dismissBackToSchoolModal } from './backToSchoolModal'

function setProductInLocalStorage(product) {
  localStorage.setItem('service.product', JSON.stringify(product))
  return null
}

export function fetchService() {
  return (dispatch) => api.fetch('/service')
    .then((response) => {
      dispatch({ type: 'FETCH_SERVICE_SUCCESS', response })
      setProductInLocalStorage(response.product)
    })
    .catch(() => {})
}

export function initiateUpgrade({ plan, idempotencyKey }) {
  return () => api.post(
    '/service/initiate-upgrade',
    { plan, idempotencyKey },
  )
}

export function switchPlan(plan, coupon) { // Switch between monthly/yearly plans
  const requestData = { plan }
  if (coupon) {
    requestData.coupon = coupon
  }
  return (dispatch) => api.put('/service/switch-plan', requestData)
    .then((response) => {
      dispatch(dismissBackToSchoolModal())
      dispatch({ type: 'SWITCH_PLAN_SUCCESS', response })
      dispatch(fetchDiscounts())
      dispatch(fetchBilling())
      dispatch(fetchInvoices())
      dispatch(fetchPreviewInvoice())
      setProductInLocalStorage(response.product)
      return response
    })
}

export function cancelService() {
  return (dispatch) => api.put('/service/cancel')
    .then((response) => {
      dispatch(dismissBackToSchoolModal())
      dispatch({ type: 'UPDATE_SERVICE_SUCCESS', response })
      return response
    })
    .catch(() => {})
}

export function revertServiceCancellation() {
  return async (dispatch) => {
    const response = await api.put('/service/revert-cancellation')
    dispatch({ type: 'UPDATE_SERVICE_SUCCESS', response })
    setProductInLocalStorage(response.product)
    return response
  }
}
